import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { apiClient } from "../api/client";

// DELETE /api/v1/me cascade-deletes the user, their products, runs,
// drafts, sessions, and API tokens. The orchestrator requires a literal
// `{"confirm":"DELETE"}` body — the modal's "type DELETE to confirm"
// gate matches the server-side gate so a misclick on the button can't
// destroy the account. On success we wipe the entire query cache and
// bounce to /login with `?deleted=1` so the Login page can render a
// one-shot success message inline (no global toast system in v1).
export function useDeleteAccount() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: async () => {
      const { data, error } = await apiClient.DELETE("/api/v1/me", {
        params: { header: { "X-Requested-With": "xhr" } },
        body: { confirm: "DELETE" },
      });
      if (error) throw error;
      return data;
    },
    onSuccess: () => {
      // Clear EVERYTHING — products, runs, /me, anything user-scoped.
      // Then navigate; the Login page reads ?deleted=1 and shows a
      // confirmation message.
      queryClient.clear();
      navigate("/login?deleted=1", { replace: true });
    },
  });
}
